"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = void 0;
/**
 * Add up all values in `v`, with property selected by `picker`
 *
 * @example sum([{ a: 1 }, { a: 2 }, { z: 2 }], v => v.a); // 3
 */
const sum = (v, picker, initial = 0) => v.reduce((acc, curr) => acc + picker(curr), initial);
exports.sum = sum;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL3N1bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7OztHQUlHO0FBQ0ksTUFBTSxHQUFHLEdBQUcsQ0FBSSxDQUFNLEVBQUUsTUFBd0IsRUFBRSxVQUFrQixDQUFDLEVBQVUsRUFBRSxDQUN0RixDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsR0FBRyxFQUFFLElBQUksRUFBRSxFQUFFLENBQUMsR0FBRyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsRUFBRSxPQUFPLENBQUMsQ0FBQztBQUQxQyxRQUFBLEdBQUcsT0FDdUMifQ==